import { delayedCall, dispatcher, IEvent, ingenuity } from "@quest/base-core";
import {
  FreeGameWinPresentationControllerBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
export class FreeGameWinPresentationControllerGame extends FreeGameWinPresentationControllerBehavior {
  protected onSuspendWinPresentation(): void {
    super.onSuspendWinPresentation();
    dispatcher.fireEvent(eventDispatchers.STOP_STICKY_WIN_ANIM);
  }
  /**
   * play freegame big win animation when win > currentBet * 5
   * @param evt 
   */
  protected onStartBigWinPresentation(evt: IEvent): void {
    this.cofigureEventOnBigWinHide();
    if (this.model.getIsFgBigWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BIG_WIN_FG);
    }
  }
  /**
   * play stack animation
   */
  protected onShowAllFrames(): void {
    (ingenuity.parserModel as GameParserModel).getIsWildWin() &&
      (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_WIN_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    (ingenuity.parserModel as GameParserModel).setIsWildWin(false);
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresentFG() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0
    ) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_STACK_SYM_ANIM_FG);
    }
    const windata = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASEGAME_WIN_ALPHA, windata);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA_ON_SYMBOL, windata);
    if (this.paylineView) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_ALL_FRAMES, {
        callback() {
          if (this.model.getIsFgBigWin()) {
            dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
          }
        },
        callbackScope: this,
        delayTimer: this.model.getDelayForSpaghttiDispaly(),
        winData: windata,
        display: true,
      });
    } else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }
    if (ingenuity.configData.playAllSymbolAnim) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
    // Play all anim with delay to show stack before static hide.
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresentFG() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0
    ) {
      delayedCall(
        SlotConstantsBehavior.PLAY_ANIM_DELAY_FOR_STACK,
        SlotConstantsBehavior.DURATION_100,
        () => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
        },
        this
      );
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
  }
}
